const state = {
  showMenuReserves: null,
  syncSienge: null,
  docObrigatory: null,
  conjugateData: null
}

const mutations = {
  setShowMenuReserve (state, payload) {
    state.showMenuReserves = payload
  },
  setSyncSienge (state, payload) {
    state.syncSienge = payload
  },
  setDocObrigatory (state, payload) {
    state.docObrigatory = payload
  },
  setConjugateData (state, payload) {
    state.conjugateData = payload
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js